module.exports = __webpack_public_path__ + "static/img/active6.08c7e0ca.png";